import { Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Input from '../../../Components/Input/Input';
import ajclWhiteLogo from "../../../images/ajcl_logo_white.png";
import { resetPassword } from '../../../Redux/Action/Auth';
import { errorNotify, successNotify } from '../../../Utils/Toast';
import { resetPasswordSchema } from '../../../Utils/Validations';

const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const { loading, resetApiData, error } = useSelector((state) => state.resetAuth);

  useEffect(() => {
    if (!token) {
      navigate('/');
      return;
    }
  }, [token]);

  useEffect(() => {
    if (resetApiData?.statusCode === 200) {
      successNotify("Password reset successfully!");
      navigate('/');
      dispatch({ type: "RESET_PASSWORD_RESET" });
    } 
    else if (error) {
      errorNotify(error);
      dispatch({ type: "RESET_PASSWORD_RESET" });
    }
  }, [resetApiData, error]);

  return (
    <div className='login_wrapper'>
      <Container fluid>
        <Row>
          <Col md={6} className='login_left_side'>
            <div>
              <img src={ajclWhiteLogo} alt="logo" className='main_logo' />
              <h1>Tender Management System</h1>
            </div>
          </Col>
          <Col md={6} className='login_right_side'>
            <div className='login_form_wrapper'>
              <div className='login_form_heading'>
                <h2>Reset Password</h2>
                <p>Please enter your new password.</p>
              </div>

              <Formik
                initialValues={{
                  password: '',
                  confirm_password: ''
                }}
                validationSchema={resetPasswordSchema}
                onSubmit={(values) => {
                  const formData = new FormData();
                  formData.append('password', values.password);
                  formData.append('confirm_password', values.confirm_password);
                  formData.append('token', token);

                  dispatch(resetPassword(formData));
                }}
              >
                {() => (
                  <Form>
                    <div className='login_form_fields'>
                      <Input
                        type="password"
                        name="password"
                        label="New Password"
                        placeholder="Enter new password"
                      />
                      <Input
                        type="password"
                        name="confirm_password"
                        label="Confirm Password"
                        placeholder="Confirm new password"
                      />
                      <button
                        type="submit"
                        disabled={loading}
                        className='login_btn mt-3'
                      >
                        {loading ? <Spinner animation='border' size='sm' /> : 'Reset Password'}
                      </button>
                    </div>
                    <div className='auth_links mt-3'>
                      <p>Remember your password? <Link to="/">Login</Link></p>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ResetPassword;